import { render, staticRenderFns } from "./teamDirverEdit.vue?vue&type=template&id=054de7c2&scoped=true"
import script from "./teamDirverEdit.vue?vue&type=script&lang=js"
export * from "./teamDirverEdit.vue?vue&type=script&lang=js"
import style0 from "./teamDirverEdit.vue?vue&type=style&index=0&id=054de7c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054de7c2",
  null
  
)

export default component.exports